import React, { useState } from "react";
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  Button,
  Typography,
} from "@material-ui/core";
import { filter } from "lodash";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import * as locales from "@material-ui/core/locale";
import Scrollbar from "../Scrollbar";
import { TablaHead } from "../_dashboard/tablas";

const TABLE_HEAD = [
  { id: "nombreCliente", label: "Cliente", alignRight: false },
  { id: "nombreEmpleado", label: "Nombre Empleado", alignRight: false },
  { id: "refTipoPlan", label: "Nombre del Plan", alignRight: false },
  { id: "valor", label: "Valor", alignRight: false },
  { id: "descuento", label: "Descuento", alignRight: false },
  { id: "valorDesc", label: "Valor con Descuento", alignRight: false },
  { id: "fechaTerminoDesc", label: "Término del descuento", alignRight: false },
  { id: "frecuencia", label: "Frecuencia", alignRight: false },
  { id: "" },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user.nombreCliente.toLowerCase().indexOf(query.toLowerCase()) !== -1,
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function TablaPlanMasivo(props) {
  const { planes, setPlanes, datosPlanes, setDatosPlanes } = props;
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("nombre");
  const filterName = "";
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [locale] = useState("esES");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = planes?.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - planes?.length) : 0;

  const filteredUsers = applySortFilter(
    planes,
    getComparator(order, orderBy),
    filterName,
  );

  const isUserNotFound = filteredUsers.length === 0;

  const eliminar = (row) => {
    const totalPlanes = [...planes];
    const datosTotalPlanes = [...datosPlanes];
    const index = totalPlanes.indexOf(row);
    totalPlanes.splice(index, 1);
    datosTotalPlanes.splice(index, 1);
    setPlanes(totalPlanes);
    setDatosPlanes(datosTotalPlanes);
  };

  return (
    <div>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <TablaHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={planes?.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const {
                      nombreCliente,
                      refTipoPlan,
                      nombreEmpleado,
                      descuento,
                      valorDesc,
                      valor,
                      tipoMoneda,
                      fechaTerminoDesc,
                      frecuencia,
                      tipoFrecuencia,
                    } = row;
                    const isItemSelected =
                      selected.indexOf(nombreCliente) !== -1;

                    return (
                      <TableRow
                        hover
                        key={
                          nombreCliente +
                          refTipoPlan +
                          descuento +
                          nombreEmpleado
                        }
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell>
                          <Typography variant="subtitle2">
                            {nombreCliente}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          {nombreEmpleado.toUpperCase()}
                        </TableCell>
                        <TableCell align="left">{refTipoPlan}</TableCell>
                        <TableCell align="left">
                          {valor} {tipoMoneda}{" "}
                        </TableCell>
                        <TableCell align="left">
                          {descuento} {" %"}
                        </TableCell>
                        <TableCell align="left">
                          {valorDesc} {tipoMoneda}
                        </TableCell>
                        <TableCell align="left">
                          {descuento > 0 ? fechaTerminoDesc : "-"}
                        </TableCell>
                        <TableCell align="left">
                          {frecuencia} {tipoFrecuencia}
                        </TableCell>
                        <TableCell align="right">
                          <Button
                            color="error"
                            onClick={() => {
                              eliminar(row);
                            }}
                          >
                            Eliminar
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      No se han agregado elementos
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <ThemeProvider
          theme={(outerTheme) => createTheme(outerTheme, locales[locale])}
        >
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={planes?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </Card>
    </div>
  );
}
